import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./initialState.js";
import { SEARCH_OPTION_SECTION } from "../../../constants/index.js";
import { getVisualBuilderMode } from "../../../utils/visualBuilder";

export const searchOptionsSelector = (params, section) =>
  createSelector(
    (state) => state.searchOptions,
    (searchOptions) => {
      const { key: vbKey, mode } = getVisualBuilderMode(params);
      const { propertyId } = params;

      let key = "";

      if (section === SEARCH_OPTION_SECTION.MEDIA_ITEM) {
        key = `${section}/${propertyId}`;
      }

      if (section === SEARCH_OPTION_SECTION.VISUAL_BUILDER) {
        key = `${mode}/${vbKey}`;
      }

      return {
        ...initialState,
        ...(searchOptions[key] || {}),
      };
    },
  );
